// 3511QueryYB.js - 医保销售信息查询接口
import { ybRequestTemplate } from "/src/untils/ybRequestTemplate.js"
import { addYbRquestData, getqdNo } from "@/api/yb";
import axios from "axios";
import dayjs from "dayjs";
/**
 * 医保销售信息查询接口 (3511)
 * @param {Object} row - 要查询的行数据
 * @param {Object} userData - 用户信息
 * @param {Object} clinicInfo - 诊所信息
 * @param {String} startTime - 开始时间
 * @param {String} endTime - 结束时间
 * @param {Function} addStepMessage - 添加步骤消息的函数
 * @param {Function} addOperationStepMessage - 添加操作步骤消息的函数
 * @param {Function} updateOperationProgress - 更新进度条的函数
 * @param {Function} updateOperationStepStatus - 更新步骤状态的函数
 * @returns {Promise} 查询结果
 */
export const queryMedicalInsuranceStorage3511 = async (
  row, 
  userData, 
  clinicInfo, 
  startTime,  // 新增：开始时间参数
  endTime,    // 新增：结束时间参数
  addStepMessage, 
  addOperationStepMessage, 
  updateOperationProgress,
  updateOperationStepStatus
) => {
  try {
    addStepMessage('开始执行医保销售信息查询流程(3511)...');
    
    // 准备查询请求数据
    addOperationStepMessage('准备查询请求数据...');
    const ybRequest = JSON.parse(JSON.stringify(ybRequestTemplate));
    const today = dayjs().format('YYYY-MM-DD');
    
    // 获取签到编号
    const signNoRes = await getqdNo();
    let signNo = '';
    if (signNoRes.code === 200) {
      signNo = signNoRes.data.signNo;
      addStepMessage(`签到业务ID: ${signNo}`);
    } else {
      throw new Error('获取签到流水号失败');
    }
    
    // 设置请求参数 - 3511接口
    ybRequest.body.infno = '3511';
    ybRequest.body.msgid = `${userData.clinicCode || '000000'}${dayjs().format('YYYYMMDDHHmmss')}${getRandom4Digits()}`;
    ybRequest.body.insuplc_admdvs = userData.mdtrtareaAdmvs || '';
    ybRequest.body.mdtrtarea_admdvs = userData.mdtrtareaAdmvs || '';
    ybRequest.body.recer_admdvs = userData.mdtrtareaAdmvs || '';
    ybRequest.body.recer_sys_code = '007';
    ybRequest.body.infver = 'V1.049';
    ybRequest.body.opter_type = '1';
    ybRequest.body.opter = userData.userId || '1';
    ybRequest.body.opter_name = userData.staffName || '系统操作员';
    ybRequest.body.inf_time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    ybRequest.body.fixmedins_code = userData.clinicCode || '';
    ybRequest.body.fixmedins_name = userData.clinicName || '';
    ybRequest.body.sign_no = signNo;
    
    // 格式化时间参数
    const formattedStartTime = startTime ? dayjs(startTime).format('YYYY-MM-DD') : '';
    const formattedEndTime = endTime ? dayjs(endTime).format('YYYY-MM-DD') : '';
    
    // 设置查询数据 - 根据3511接口规范
    ybRequest.body.input.data = {
		fixmedins_code: row.medListCodg || '', // 定点医药机构编号
		medins_list_codg: row.medListCodg || '', // 定点医药机构医疗目录编码
		fixmedins_bchno: row.bchno || '', // 使用行数据中的定点医药机构批次流水号
		fixmedins_hilist_id: row.fixmedinsHilistId || '', // 定点医药机构目录编号
		begndate: formattedStartTime, // 使用传入的开始时间
		enddate: formattedEndTime,    // 使用传入的结束时间
		medins_prod_sel_no: '', // 定点医药机构商品销售流水号
		med_list_codg: '' ,// 医疗目录编码
		medins_list_name:'', // 医药机构目录名称
		prsc_dr_cert_type:'', // 开单医师证件类型
		prsc_dr_certno:'', // 开单医师证件号码
		bilg_dr_name:'', // 开单医师姓名
		phar_cert_type:'', // 药师证件类型
		phar_certno:'', // 药师证件号码
		phar_name:'', // 药师姓名
		phar_prac_cert_no:'', // 药师职业资格证号码
		hi_feesetl_type:'', // 医保费用结算类型
		setl_id:'', // 结算ID
		psn_no:'', // 人员编号
		psn_cert_type:'', // 人员证件类型
		certno:'', // 证件号码
		psn_name:'', // 人员姓名
		manu_lotnum:'', // 生产批号
		manu_date:'', // 生产日期
		expy_end:'', // 有效期
		elec_supn_codg:'', // 电子监管编码
		rx_flag: getRxFlag(row) || '0', // 处方药标志
		list_sp_item_flag:'', // 目录特项标志
		trdn_flag:'', // 拆零标志
		sel_retn_time:'', // 销售/退货时间
		sel_retn_opter_name:'', // 销售/退货经办人姓名
		memo:'', // 备注
		vali_flag:'', // 有效标志
		rid:'', // 数据唯一记录号
		crter_id:'', // 创建人ID
		crter_name:'', // 创建人姓名
		crte_optins_no:'', // 创建机构编号
		opter_id:'', // 经办人ID
		opter_name:'', // 经办人姓名
		optins_no:'', // 经办机构编号
		poolarea_no:'', // 统筹区编号

    };
    
    addStepMessage(`查询时间范围: ${formattedStartTime} 至 ${formattedEndTime}`);
    addStepMessage('准备调用接口查询销售信息(3511)...');
    
    // 先传给系统
    const newItem = {
      infno: 3511,
      mdtrtareaAdmvs: userData.mdtrtareaAdmvs || '',
      data: JSON.stringify(ybRequest.body),
      patientId: userData.staffId || '',
      patientName: userData.staffName || '系统操作员'
    };
    
    const res = await addYbRquestData(newItem);
    
    if (res.code !== 200) {
      throw new Error('医保查询数据准备失败: ' + res.message);
    }
    
    addStepMessage('医保查询数据准备完成，开始调用接口(3511)...');
    
    let responseData = res.data;
    if (typeof responseData === 'string') {
      try {
        responseData = JSON.parse(responseData);
      } catch (parseError) {
        throw new Error('解析医保响应数据失败');
      }
    }
    
    // 设置请求头
    ybRequest.headers.infosyscode = responseData.infosyscode || '';
    ybRequest.headers.hsf_signature = responseData.signature || '';
    ybRequest.headers.fixmedins_code = userData.clinicCode || '';
    ybRequest.headers.hsf_nonce = responseData.hsfNonce || '';
    ybRequest.headers.hsf_timestamp = responseData.hsfTimestamp || '';
    
    addStepMessage('调用医保销售信息查询接口(3511)...');
    updateOperationProgress(70);
    updateOperationStepStatus(1, 'loading');
    
    // 调用医保接口
    const axiosConfig = {
      method: 'post',
      url: process.env.VUE_APP_BASE_YBHOST + `/eapdomain/callService`,
      baseURL: '',
      headers: ybRequest.headers,
      data: ybRequest.body,
    };
    
    const response = await axios(axiosConfig);
    const result = response.data || response;
    
    // 处理响应结果
    if (result.infcode === 0) {
      addStepMessage('医保销售信息查询成功(3511)', { level: 'success' });
      updateOperationProgress(100);
      updateOperationStepStatus(1, 'success');
      
      // 处理查询结果数据
      if (result.output && result.output.data) {
        addStepMessage(`查询到 ${result.output.data.length} 条销售信息`, { level: 'success' });
      }
      
      return result;
    } else {
      let errorMsg = '医保销售信息查询失败(3511)';
      if (result) {
        errorMsg = result.err_msg || result.msg || result.message || '未知错误';
      }
      throw new Error(errorMsg);
    }
    
  } catch (error) {
    console.error('调用医保销售信息查询接口(3511)异常:', error);
    updateOperationProgress(100);
    updateOperationStepStatus(1, 'error');
    throw error;
  }
};
/**
 * 生成4位随机数
 * @returns {string} 4位随机数字
 */
const getRandom4Digits = () => {
  return Math.floor(1000 + Math.random() * 9000).toString();
};
// 添加辅助函数：判断是否为处方药
const getRxFlag = (row) => {
  const rxKeywords = ['抗生素', '麻醉', '精神', '处方', 'RX'];
  const drugName = row.fixmedinsHilistName || '';
  
  return rxKeywords.some(keyword => drugName.includes(keyword)) ? '1' : '0';
};